import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  baseurl: 'https://api.cmshj.com',
  imgbase: 'https://api.cmshj.com',
  taskType: {0: '百度指数', 1: '资讯指数', 2: '媒体指数'},
  online: {0: '下线', 1: '上线'},
  status: {0: '未开始', 1: '执行中', 2: '完成'},
  ckstate: {0: '可用', 1: '被封', 2: '错误'},
  isLogin: false,

  vipinfo: null
}

if (process.env.NODE_ENV === 'development') {
  state.baseurl = 'http://ky.localhost'
  state.imgbase = 'http://ky.localhost'
}

const store = new Vuex.Store({
  state,
  mutations: {
    SETVIP: (state, param) => {
      state.vipinfo = param
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js